module.exports = __webpack_public_path__ + "img/exit-icon.9fbed2f4.svg";